import { useLanguage } from '../../i18n/LanguageContext';

interface DealerStatePageProps {
  reason: 'featureOff' | 'blocked' | 'error';
  /** The 403 code behind `blocked` (DEALER_SUSPENDED, DEALER_NOT_ACTIVE, NOT_A_DEALER_USER). */
  code?: string | null;
  onRetry?: () => void;
  onLogout?: () => void;
}

/**
 * Spec 085 — the whole-screen states of the dealer portal: switch off (Flow K: "Dealer credit is not
 * available right now"), a blocked membership (BR-5) or a load failure.
 */
export default function DealerStatePage({ reason, code, onRetry, onLogout }: DealerStatePageProps) {
  const { t } = useLanguage();
  let title: string;
  let body: string;
  if (reason === 'featureOff') {
    title = t('dealer.featureOff.title');
    body = t('dealer.featureOff.body');
  } else if (reason === 'blocked') {
    title = t('dealer.blocked.title');
    body = t(code === 'DEALER_NOT_ACTIVE' ? 'dealer.blocked.notActive'
      : code === 'NOT_A_DEALER_USER' ? 'dealer.blocked.notMember' : 'dealer.blocked.suspended');
  } else {
    title = t('dealer.loadError.title');
    body = t('dealer.loadError.body');
  }
  return (
    <div className="dealer-state" role="status" data-testid={`dealer-state-${reason}`}>
      <h2>{title}</h2>
      <p>{body}</p>
      <div className="dealer-state__actions">
        {onRetry && <button type="button" className="btn btn-primary" onClick={onRetry}>{t('dealer.common.retry')}</button>}
        {onLogout && <button type="button" className="btn btn-secondary" onClick={onLogout}>{t('nav.logout')}</button>}
      </div>
    </div>
  );
}
